import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { OrderType } from '../../../../lib/lib-shared/types/OrderType';

@Component({
  selector: 'lm-order-ship-return-validate-modal',
  templateUrl: './order-ship-return-validate-modal.component.html',
  styleUrls: ['./order-ship-return-validate-modal.component.scss']
})
export class OrderShipReturnValidateModalComponent {
  public orderType: OrderType = null;
  public freeReturn = new FormControl(false);

  constructor(
    public activeModal: NgbActiveModal,
  ) {
  }

  get showFreeReturn(): boolean {
    return [OrderType.KIT, OrderType.PICKUP].includes(this.orderType);
  }

  validate() {
    this.activeModal.close({freeReturn: this.showFreeReturn && this.freeReturn.value});
  }
}
